import { gql } from 'graphql-tag'

export default gql`
  fragment ModuleTerminalPaymentExperienceSpecsFragment on ModuleTerminalPaymentExperienceSpecs {
    giftcards
    debitCredit
    localPaymentMehtods
    ewallets
    recurringPayments
    dcc
    tips
    languages
    custom
    taxfree
    contactlessOnly
    chip
    offline
    standalone
    walletPasses
    adyenGiving
    surcharging
    installments
    nfcTags
    accessibleAudioGuide
    payAtTable
    cashback
  }
`
